var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.dialog,
            width: "700",
            "hide-overlay": "",
            transition: "dialog-bottom-transition",
          },
          on: {
            "click:outside": function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [
          _c(
            "v-card",
            {},
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.uploadFiles.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c("span", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.modal_title)),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", [
                    _c("div", { staticClass: "container-documents mt-5" }, [
                      _c(
                        "div",
                        {
                          staticClass: "drop-area",
                          on: {
                            dragover: function ($event) {
                              $event.preventDefault()
                            },
                            dragenter: function ($event) {
                              $event.preventDefault()
                            },
                            drop: function ($event) {
                              $event.preventDefault()
                              return _vm.handleDrop.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "download-icon",
                            attrs: { icon: "fa-download" },
                            on: { click: _vm.triggerFileInput },
                          }),
                          _c("p", { staticClass: "mt-4 mb-0" }, [
                            _vm._v(
                              "Suelta los archivos aquí o haz clic para seleccionarlos"
                            ),
                          ]),
                          _c("input", {
                            ref: "hiddenFileInput",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              multiple: "",
                              accept:
                                ".pdf, .xls, .xlsx, .doc, .docx, .png, .jpg, .jpeg",
                            },
                            on: { change: _vm.handleFileChange },
                          }),
                          _vm.files.length
                            ? _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    "v-list",
                                    _vm._l(_vm.files, function (item, index) {
                                      return _c(
                                        "v-list-item",
                                        { key: index },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "text-left" },
                                                [_vm._v(_vm._s(item.file.name))]
                                              ),
                                              item.status === "loading"
                                                ? _c("v-progress-linear", {
                                                    attrs: {
                                                      indeterminate: "",
                                                      color: "primary",
                                                      size: "20",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            { staticClass: "mt-0 mb-0" },
                                            [
                                              item.status === "success"
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "green" },
                                                    },
                                                    [_vm._v("mdi-check-circle")]
                                                  )
                                                : _vm._e(),
                                              item.status === "error"
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { color: "red" } },
                                                    [_vm._v("mdi-alert-circle")]
                                                  )
                                                : _vm._e(),
                                              item.status != "success" &&
                                              item.status != "error"
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "red",
                                                        icon: "",
                                                        disabled:
                                                          item.status ===
                                                          "loading",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeFile(
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-close")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_vm._v("Cerrar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            text: "",
                            type: "submit",
                            loading: _vm.loading,
                            disabled: _vm.btn_disabled,
                          },
                        },
                        [_vm._v("Subir")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }